<script setup>
import {
  computed,
} from 'vue';

const props = defineProps({
  small: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: 'primary',
  },
  text: {
    type: String,
    required: false,
  },
})

const spinnerClass = computed(() => {
  let classes = [
    `text-${props.color}`,
  ];
  if (props.small) {
    classes.push('spinner-grow-sm');
  }
  return classes;
})
</script>

<template>
  <span class="text-center">
    <span class="d-flex flex-column justify-content-center align-items-center">
      <span
        class="spinner-grow"
        :class="spinnerClass"
        role="status"
      >
        <span class="sr-only">{{ $t('word.loading') }}...</span>
      </span>
      <span
        class="mt-2"
        v-if="text"
      >
        {{ $t(text) }}
      </span>
    </span>
  </span>
</template>
